import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AppService } from './app.service';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private localStorage: LocalStorageService,
    private authService: AuthService,
    private appService: AppService,
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.getProfile().pipe(
      map(it => {
        if (it.successFlag && it.isAuthenticated) {
          const userProfile = it.userData;
          this.localStorage.store('profile', userProfile);
          this.appService.setUserLoggedIn(true);
          return true;
        } else {
          this.redirectToLogin();
          return false;
        }
      }),
      catchError(() => {
        this.redirectToLogin();
        return of(false);
      })
    );
  }

  private redirectToLogin(): void {
    window.location.href = `${environment.logoutUrl}?error=${encodeURIComponent('Failed to fetch user profile.')}`;
  }
}
